// ABOUTME: The owner's first ask, written in onboarding's last step and sent by the Marketing
// chat as their first message once it opens. In memory only: it lives for one navigation.
import { create } from 'zustand'
import type { AttachmentRef } from '@/types'

export interface FirstAsk {
  text: string
  attachments: AttachmentRef[]
}

interface FirstAskStore {
  ask: FirstAsk | null
  set: (ask: FirstAsk) => void
  /** Returns the ask and clears it, so it is sent once. */
  take: () => FirstAsk | null
}

export const useFirstAskStore = create<FirstAskStore>((set, get) => ({
  ask: null,
  set: (ask) => set({ ask }),
  take: () => {
    const ask = get().ask
    if (ask) set({ ask: null })
    return ask
  },
}))
